import { StakingModal } from "./StakingModal";
import { useCallback, useState } from "react";
import { StakingBanner } from "./StakingBanner";
import { useProjectDetailsParams } from "../../hooks/useProjectDetailsParams";
import { useIsStakable } from "./hooks/useIsStakable";
import { useDonationPeriod } from "./hooks/useDonationPeriod";
import { StakingButton } from "./StakingButton";
import { StakingCountDownLabel } from "./StakingCountDownLabel";
import { Button } from "../../../../collections/CollectionDetails";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/20/solid";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const STAKING_APP_URL = process.env.REACT_APP_STAKING_APP;
const COUNTDOWN_LABEL = "Staking begins in";
const COUNTDOWN_LIMIT_MINUTES = 3;
export const StakingBannerAndModal = _ref => {
  let {
    isRoundView
  } = _ref;
  const [isOpen, setIsOpen] = useState(false);
  const {
    chainId,
    roundId,
    applicationId: paramApplicationId
  } = useProjectDetailsParams();
  const applicationId = paramApplicationId !== null && paramApplicationId !== void 0 && paramApplicationId.includes("-") ? paramApplicationId.split("-")[1] : paramApplicationId;
  const stakeProjectUrl = `${STAKING_APP_URL}/#/staking-round/${chainId}/${roundId}?id=${applicationId}`;
  const stakeRoundUrl = `${STAKING_APP_URL}/#/staking-round/${chainId}/${roundId}`;
  const claimRewardsUrl = `${STAKING_APP_URL}/#/claim-rewards`;
  const handleCloseModal = useCallback(() => {
    setIsOpen(false);
  }, []);
  const handleOpenModal = useCallback(() => {
    setIsOpen(true);
  }, []);
  const handleStake = useCallback(() => {
    window.open(stakeProjectUrl, "_blank");
    handleCloseModal();
  }, [handleCloseModal, stakeProjectUrl]);
  const handleStakeRound = useCallback(() => {
    window.open(stakeRoundUrl, "_blank");
    handleCloseModal();
  }, [handleCloseModal, stakeRoundUrl]);
  const handleClaimRewards = useCallback(() => {
    window.open(claimRewardsUrl, "_blank");
  }, [claimRewardsUrl]);
  const chainIdNumber = chainId ? parseInt(chainId, 10) : 0;
  const isStakable = useIsStakable({
    chainId: chainIdNumber,
    roundId
  });
  const {
    isDonationPeriod,
    timeToDonationStart,
    timeToDonationEnd
  } = useDonationPeriod({
    chainId: chainIdNumber,
    roundId,
    refreshInterval: 60 * 1000 // 1 minute
  });
  const isCountDownToStartPeriod = timeToDonationStart && timeToDonationStart.totalMilliseconds > 0;
  const isRoundEnded = timeToDonationEnd && timeToDonationEnd.totalMilliseconds < 0;
  if (isStakable && isRoundEnded) {
    return /*#__PURE__*/_jsx("div", {
      className: "mt-2 items-center justify-center",
      children: /*#__PURE__*/_jsx(StakingBanner, {
        isRoundView: isRoundView,
        isClaimPeriod: true,
        children: /*#__PURE__*/_jsx(StakingButton, {
          onClick: handleClaimRewards,
          isRoundView: isRoundView,
          isClaimPeriod: true
        })
      })
    });
  }
  if (isStakable && isCountDownToStartPeriod) {
    return /*#__PURE__*/_jsx("div", {
      className: "mt-2 mb-6",
      children: /*#__PURE__*/_jsx(StakingBanner, {
        isRoundView: isRoundView,
        children: /*#__PURE__*/_jsx(StakingCountDownLabel, {
          timeLeft: timeToDonationStart,
          label: COUNTDOWN_LABEL,
          limitMinutes: COUNTDOWN_LIMIT_MINUTES,
          isRoundView: isRoundView
        })
      })
    });
  }
  if (isStakable && isDonationPeriod) {
    return /*#__PURE__*/_jsxs("div", {
      className: "mt-2 mb-6",
      children: [/*#__PURE__*/_jsx(StakingBanner, {
        isRoundView: isRoundView,
        children: /*#__PURE__*/_jsxs("div", {
          className: "flex items-center gap-2",
          children: [/*#__PURE__*/_jsx(StakingButton, {
            onClick: handleOpenModal,
            isRoundView: isRoundView
          }), isRoundView && /*#__PURE__*/_jsxs(Button, {
            onClick: () => {
              window.open("https://dashboard.boost.explorer.gitcoin.co/about-explorer-boost", "_blank");
            },
            className: "text-black text-sm font-mono font-medium px-4 py-2 leading-normal rounded-lg inline-flex justify-center items-center gap-2 bg-transparent hover:bg-transparent",
            children: ["Learn more", /*#__PURE__*/_jsx(ArrowTopRightOnSquareIcon, {
              className: "w-4 h-4"
            })]
          })]
        })
      }), /*#__PURE__*/_jsx(StakingModal, {
        isOpen: isOpen,
        onClose: handleCloseModal,
        onStake: isRoundView ? handleStakeRound : handleStake,
        isRoundView: isRoundView !== null && isRoundView !== void 0 ? isRoundView : false
      })]
    });
  }
  return null;
};